import { type ListGlobalCloudProvidersDto } from '@/api/services/platform';

/**
 * Returns boolean indicating if any of the cloud providers in the list is available as a free tier.
 */
export const isFreeTierCloudProviderAvailable = (cloudProviders: ListGlobalCloudProvidersDto) =>
  cloudProviders.some((provider) => provider.freeTier);
